import { interval, Subscription } from 'rxjs';
import { HowChooseColor, HowChooseColorSet } from './../how-choose-color';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-how-choose-color',
  templateUrl: './how-choose-color.component.html',
  styleUrls: ['./how-choose-color.component.sass']
})
export class HowChooseColorComponent implements OnInit {
  title: string = "DOWIEDZ SIĘ JAK WYBIERAĆ KOLORY";
  subtitle: string = "Przeczytaj praktyczne wskazówki i poznaj zasady doboru kolorów na elewację. Pomogą Ci uniknąć typowych błędów.";
  next: string = "/start-project";
  tips: HowChooseColor[];
  selectedTip: HowChooseColor = null;
  selectedTipNumber: number = 0;
  sub: Subscription = null;
  numberOfSubs: number;
  constructor() { }

  ngOnInit() {
    this.tips = HowChooseColorSet
    this.numberOfSubs = this.tips.length;
    this.subscribe(true);
  }

  selectTip(tip: HowChooseColor) {
    this.selectedTip = tip;
  }

  mouseSelectTip(tip: HowChooseColor) {
    this.selectedTip = tip;
    if (tip != null) {
      this.sub.unsubscribe();
    } else {
      this.selectedTipNumber = 0;
      this.subscribe(false);
    }
  }

  private subscribe(startup: boolean) {
    if (startup) {
      setTimeout(() => {this.selectTip(this.tips[this.selectedTipNumber]);}, 400);
    }
    this.sub = interval(3000).subscribe((val) => {
      if (!this.selectTip) {
        this.selectedTipNumber = 0;
      } else {
        if (this.selectedTipNumber == this.numberOfSubs - 1) {
          this.selectedTipNumber = 0;
        } else {
          this.selectedTipNumber++;
        }
      }
      this.selectTip(this.tips[this.selectedTipNumber]);
    });
  }
}